import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgProgressModule } from "@ngx-progressbar/core";
import { SocketIoConfig, SocketIoModule } from "ngx-socket-io";
import { environment } from "../../../../environments/environment";
import { AuthModule } from "../../../core/modules/auth/auth.module";
import { SharedPipeModule } from "../../pipes/shared.pipe.module";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { NavigationComponent } from "./navigation/navigation.component";
import { PublicLayoutComponent } from "./public-layout.component";
const config: SocketIoConfig = { url: environment.socket, options: {} };

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedPipeModule,
    AuthModule,
    FormsModule,
    NgProgressModule,
    SocketIoModule.forRoot(config),
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavigationComponent,
    PublicLayoutComponent,
  ],
  entryComponents: [
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    PublicLayoutComponent,
  ],
})
export class PublicLayoutModule {}
